
const angular = require('angular');

TrackClickDirective.$inject = ['$Analytics'];

function TrackClickDirective($Analytics) {
    return {
        restrict: 'A',
        link: ($scope, $element, $attrs) => {
            const eventName = $attrs.spsuiTrackClick;
            if (eventName) {
                $element.on('click', () => {
                    $Analytics.sendEvent(eventName);
                });
            }
        }
    };
}

export default angular
    .module('spsng.directives.track-click', [])
    .directive('spsuiTrackClick', TrackClickDirective)
    .name;
